import { AnyAction, createReducer } from '@reduxjs/toolkit';

import { AssetSummaryStoreState } from '@Types/asset.types';
import { getAssetSummaryResolved } from '@Actions/assetSummary.actions';

export const initState: AssetSummaryStoreState = {
	assets: {},
};

interface AssetSummaryReducer {
	[x: string]: (
		state: AssetSummaryStoreState,
		action: AnyAction,
	) => AssetSummaryStoreState | undefined;
}

const reducer: AssetSummaryReducer = {
	[getAssetSummaryResolved.toString()]: (state, action) => ({
		...state,
		assets: {
			...state.assets,
			[action.payload.id]: action.payload.asset,
		},
	}),
};

export default createReducer(initState, reducer);
